export const FETCH_FILES_REQUEST = "FETCH_FILES_REQUEST";
export const FETCH_FILES_SUCCESS = "FETCH_FILES_SUCCESS";
export const FETCH_FILES_FAILURE = "FETCH_FILES_FAILURE";
export const FETCH_STARRED_FILES = "FETCH_STARRED_FILES";
export const FETCH_DELETED_FILES = "FETCH_DELETED_FILES";
export const UPDATE_HOME_FILES = "UPDATE_HOME_FILES";
export const UPDATE_STARRED_FILES = "UPDATE_STARRED_FILES";
export const UPDATE_DELETED_FILES = "UPDATE_DELETED_FILES";
export const FETCH_SHARED_FILES = "FETCH_SHARED_FILES";
